// import React, { useState, useEffect } from 'react';
// import { Container, Row, Col, Card, Button, Badge, Table, Form, InputGroup, Modal, Alert } from 'react-bootstrap';
// import { 
//   Plus, 
//   Search, 
//   Edit, 
//   Trash2, 
//   Tag,
//   Package,
//   RefreshCw,
//   BarChart3,
//   Palette,
//   Save,
//   X,
//   Eye
// } from 'lucide-react';
// import productService from '../../services/productService';
// import LoadingSpinner from '../common/LoadingSpinner';

// const CategoriesManagement = () => {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [searchQuery, setSearchQuery] = useState('');
  
//   // Modal states
//   const [showCreateModal, setShowCreateModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(null);
  
//   // Form data
//   const [formData, setFormData] = useState({
//     name: '',
//     icon: '📦',
//     color: '#3b82f6'
//   });
  
//   const [formErrors, setFormErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);

//   // Emojis populaires pour les catégories
//   const popularIcons = [
//     '📦', '🛍️', '👕', '👔', '👗', '👠', '👟', '🎒', '📱', '💻',
//     '🏠', '🍔', '🍕', '☕', '🍰', '🚗', '⚽', '🎮', '📚', '💊',
//     '🌟', '💎', '🎯', '🔧', '🎨', '🎪', '🎵', '🎬', '📸', '🌸'
//   ];

//   useEffect(() => {
//     loadCategories();
//   }, []);

//   /**
//    * Charger les catégories
//    */
//   const loadCategories = async () => {
//     try {
//       setLoading(true);
//       setError(null);
      
//       console.log('🏷️ Chargement des catégories...');
//       const response = await productService.getCategories();
      
//       if (response.success) {
//         setCategories(response.data || []);
//         console.log('✅ Catégories chargées:', response.data?.length || 0);
//       } else {
//         setError(response.message || 'Erreur lors du chargement des catégories');
//       }
//     } catch (error) {
//       console.error('❌ Erreur lors du chargement des catégories:', error);
//       setError('Erreur de connexion');
//     } finally {
//       setLoading(false);
//     }
//   };

//   /**
//    * Filtrer les catégories selon la recherche
//    */
//   const filteredCategories = categories.filter(category =>
//     category.name?.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   /**
//    * Valider le formulaire
//    */
//   const validateForm = () => {
//     const errors = {};
    
//     if (!formData.name?.trim()) {
//       errors.name = 'Le nom est requis';
//     } else if (formData.name.trim().length < 2) {
//       errors.name = 'Le nom doit contenir au moins 2 caractères';
//     }
    
//     if (!formData.icon) {
//       errors.icon = 'Une icône est requise';
//     }
    
//     if (!formData.color || !/^#[0-9A-Fa-f]{6}$/.test(formData.color)) {
//       errors.color = 'Couleur invalide (format #RRGGBB requis)';
//     }
    
//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   /**
//    * Créer une nouvelle catégorie
//    */
//   const handleCreate = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;
    
//     try {
//       setSubmitting(true);
      
//       const response = await productService.createCategory({
//         name: formData.name.trim(),
//         icon: formData.icon,
//         color: formData.color
//       });
      
//       if (response.success) {
//         await loadCategories();
//         resetForm();
//         setShowCreateModal(false);
//       } else {
//         setFormErrors({ submit: response.message });
//       }
//     } catch (error) {
//       console.error('❌ Erreur création catégorie:', error);
//       setFormErrors({ submit: 'Erreur lors de la création' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   /**
//    * Modifier une catégorie
//    */
//   const handleEdit = async (e) => {
//     e.preventDefault();
    
//     if (!validateForm()) return;
    
//     try {
//       setSubmitting(true);
      
//       const response = await productService.updateCategory(selectedCategory.id, {
//         name: formData.name.trim(),
//         icon: formData.icon,
//         color: formData.color
//       });
      
//       if (response.success) {
//         await loadCategories();
//         resetForm();
//         setShowEditModal(false);
//         setSelectedCategory(null);
//       } else {
//         setFormErrors({ submit: response.message });
//       }
//     } catch (error) {
//       console.error('❌ Erreur modification catégorie:', error);
//       setFormErrors({ submit: 'Erreur lors de la modification' });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   /**
//    * Supprimer une catégorie
//    */
//   const handleDelete = async () => {
//     if (!selectedCategory) return;
    
//     try {
//       setSubmitting(true);
      
//       const response = await productService.deleteCategory(selectedCategory.id);
      
//       if (response.success) {
//         await loadCategories();
//         setShowDeleteModal(false);
//         setSelectedCategory(null);
//       } else {
//         setError(response.message);
//       }
//     } catch (error) {
//       console.error('❌ Erreur suppression catégorie:', error);
//       setError('Erreur lors de la suppression');
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   /**
//    * Ouvrir le modal de modification
//    */
//   const openEditModal = (category) => {
//   setSelectedCategory(category);
//   setFormData({
//     name: category.name || '',
//     icon: category.icon || '📦',
//     color: category.color || '#3b82f6'
//   });
//   setFormErrors({}); // ✅ Reset des erreurs
//   setShowEditModal(true);
// };

//   /**
//    * Ouvrir le modal de suppression
//    */
//   const openDeleteModal = (category) => {
//     setSelectedCategory(category);
//     setShowDeleteModal(true);
//   };

//   /**
//    * Réinitialiser le formulaire
//    */
//   const resetForm = () => {
//     setFormData({
//       name: '',
//       icon: '📦',
//       color: '#3b82f6'
//     });
//     setFormErrors({});
//   };

//   /**
//    * Ouvrir le modal de création
//    */
//   const openCreateModal = () => {
//   setSelectedCategory(null); // ✅ Important : reset de la catégorie sélectionnée
//   resetForm();
//   setShowCreateModal(true);
// };

//   /**
//    * Formulaire de catégorie (création/modification)
//    */
//   const CategoryForm = ({ onSubmit, title, submitText }) => {
  
//   const handleFormSubmit = (e) => {
//     e.preventDefault();
//     onSubmit(e);
//   };

//   const handleInputChangeLocal = (field, value) => {
//     setFormData(prev => ({
//       ...prev,
//       [field]: value
//     }));
    
//     // Effacer l'erreur du champ modifié
//     if (formErrors[field]) {
//       setFormErrors(prev => ({
//         ...prev,
//         [field]: ''
//       }));
//     }
//   };

//   return (
//     <Form onSubmit={handleFormSubmit}>
//       <Modal.Header closeButton>
//         <Modal.Title>{title}</Modal.Title>
//       </Modal.Header>
      
//       <Modal.Body>
//         {formErrors.submit && (
//           <Alert variant="danger" className="mb-3">
//             {formErrors.submit}
//           </Alert>
//         )}
        
//         <Form.Group className="mb-3">
//           <Form.Label>Nom de la catégorie *</Form.Label>
//           <InputGroup>
//             <InputGroup.Text>
//               <Tag size={16} />
//             </InputGroup.Text>
//             <Form.Control
//               type="text"
//               placeholder="Ex: Vêtements, Électronique..."
//               value={formData.name}
//               onChange={(e) => handleInputChangeLocal('name', e.target.value)}
//               isInvalid={!!formErrors.name}
//             />
//             <Form.Control.Feedback type="invalid">
//               {formErrors.name}
//             </Form.Control.Feedback>
//           </InputGroup>
//         </Form.Group>

//         <Form.Group className="mb-3">
//           <Form.Label>Icône *</Form.Label>
//           <div className="mb-2">
//             <Form.Control
//               type="text"
//               placeholder="📦"
//               value={formData.icon}
//               onChange={(e) => handleInputChangeLocal('icon', e.target.value)}
//               isInvalid={!!formErrors.icon}
//               style={{ fontSize: '1.2rem' }}
//             />
//             <Form.Control.Feedback type="invalid">
//               {formErrors.icon}
//             </Form.Control.Feedback>
//           </div>
          
//           <div className="d-flex flex-wrap gap-2">
//             <small className="text-muted w-100 mb-2">Icônes populaires :</small>
//             {popularIcons.map((icon, index) => (
//               <Button
//                 key={index}
//                 variant={formData.icon === icon ? "primary" : "outline-secondary"}
//                 size="sm"
//                 className="p-2"
//                 type="button" // ✅ IMPORTANT: Empêcher la soumission du formulaire
//                 onClick={() => handleInputChangeLocal('icon', icon)}
//                 style={{ fontSize: '1.2rem', width: '40px', height: '40px' }}
//               >
//                 {icon}
//               </Button>
//             ))}
//           </div>
//         </Form.Group>

//         <Form.Group className="mb-3">
//           <Form.Label>Couleur *</Form.Label>
//           <div className="d-flex align-items-center gap-3">
//             <Form.Control
//               type="color"
//               value={formData.color}
//               onChange={(e) => handleInputChangeLocal('color', e.target.value)}
//               style={{ width: '60px', height: '40px' }}
//             />
//             <Form.Control
//               type="text"
//               value={formData.color}
//               onChange={(e) => handleInputChangeLocal('color', e.target.value)}
//               placeholder="#3b82f6"
//               isInvalid={!!formErrors.color}
//             />
//             <Form.Control.Feedback type="invalid">
//               {formErrors.color}
//             </Form.Control.Feedback>
//           </div>
//         </Form.Group>

//         <Card className="bg-light">
//           <Card.Body className="py-2">
//             <div className="d-flex align-items-center gap-2">
//               <span style={{ fontSize: '1.5rem' }}>{formData.icon}</span>
//               <span 
//                 className="px-2 py-1 rounded text-white fw-medium"
//                 style={{ backgroundColor: formData.color }}
//               >
//                 {formData.name || 'Nom de la catégorie'}
//               </span>
//             </div>
//             <small className="text-muted">Aperçu de la catégorie</small>
//           </Card.Body>
//         </Card>
//       </Modal.Body>
      
//       <Modal.Footer>
//         <Button 
//           variant="secondary" 
//           type="button" // ✅ IMPORTANT: Empêcher la soumission
//           onClick={() => {
//             setShowCreateModal(false);
//             setShowEditModal(false);
//             setSelectedCategory(null);
//             resetForm();
//           }}
//           disabled={submitting}
//         >
//           <X size={16} className="me-1" />
//           Annuler
//         </Button>
//         <Button 
//           type="submit" 
//           variant="primary"
//           disabled={submitting}
//         >
//           {submitting ? (
//             <>
//               <span className="spinner-border spinner-border-sm me-2" />
//               {submitText}...
//             </>
//           ) : (
//             <>
//               <Save size={16} className="me-1" />
//               {submitText}
//             </>
//           )}
//         </Button>
//       </Modal.Footer>
//     </Form>
//   );
// };

//   if (loading) {
//     return <LoadingSpinner message="Chargement des catégories..." />;
//   }

//   return (
//     <Container fluid className="py-4">
//       {/* En-tête */}
//       <Row className="mb-4">
//         <Col>
//           <div className="d-flex justify-content-between align-items-center">
//             <div>
//               <h1 className="h3 mb-1">
//                 <Tag className="me-2" size={28} />
//                 Gestion des Catégories
//               </h1>
//               <p className="text-muted mb-0">
//                 Organisez vos produits par catégories pour faciliter la navigation
//               </p>
//             </div>
//             <div className="d-flex gap-2">
//               <Button variant="outline-primary" 
//               type="button"
//               onClick={loadCategories}>
//                 <RefreshCw size={16} className="me-1" />
//                 Actualiser
//               </Button>
//               <Button variant="primary" 
//               type="button"
//               onClick={openCreateModal}>
//                 <Plus size={16} className="me-1" />
//                 Nouvelle catégorie
//               </Button>
//             </div>
//           </div>
//         </Col>
//       </Row>

//       {/* Statistiques */}
//       <Row className="mb-4">
//         <Col lg={3} md={6} className="mb-3">
//           <Card className="border-0 shadow-sm">
//             <Card.Body>
//               <div className="d-flex align-items-center">
//                 <div className="bg-primary rounded p-3 me-3">
//                   <Tag size={24} className="text-white" />
//                 </div>
//                 <div>
//                   <h3 className="mb-1">{categories.length}</h3>
//                   <p className="text-muted mb-0 small">Total catégories</p>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
        
//         <Col lg={3} md={6} className="mb-3">
//           <Card className="border-0 shadow-sm">
//             <Card.Body>
//               <div className="d-flex align-items-center">
//                 <div className="bg-success rounded p-3 me-3">
//                   <Package size={24} className="text-white" />
//                 </div>
//                 <div>
//                   <h3 className="mb-1">
//                     {categories.reduce((sum, cat) => sum + (cat.product_count || 0), 0)}
//                   </h3>
//                   <p className="text-muted mb-0 small">Produits associés</p>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
        
//         <Col lg={3} md={6} className="mb-3">
//           <Card className="border-0 shadow-sm">
//             <Card.Body>
//               <div className="d-flex align-items-center">
//                 <div className="bg-warning rounded p-3 me-3">
//                   <BarChart3 size={24} className="text-white" />
//                 </div>
//                 <div>
//                   <h3 className="mb-1">
//                     {categories.filter(cat => (cat.product_count || 0) > 0).length}
//                   </h3>
//                   <p className="text-muted mb-0 small">Catégories actives</p>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
        
//         <Col lg={3} md={6} className="mb-3">
//           <Card className="border-0 shadow-sm">
//             <Card.Body>
//               <div className="d-flex align-items-center">
//                 <div className="bg-info rounded p-3 me-3">
//                   <Palette size={24} className="text-white" />
//                 </div>
//                 <div>
//                   <h3 className="mb-1">
//                     {new Set(categories.map(cat => cat.color)).size}
//                   </h3>
//                   <p className="text-muted mb-0 small">Couleurs utilisées</p>
//                 </div>
//               </div>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Barre de recherche */}
//       <Row className="mb-4">
//         <Col lg={6}>
//           <InputGroup>
//             <InputGroup.Text>
//               <Search size={16} />
//             </InputGroup.Text>
//             <Form.Control
//               type="text"
//               placeholder="Rechercher une catégorie..."
//               value={searchQuery}
//               onChange={(e) => setSearchQuery(e.target.value)}
//             />
//           </InputGroup>
//         </Col>
//       </Row>

//       {/* Messages d'erreur */}
//       {error && (
//         <Alert variant="danger" dismissible onClose={() => setError(null)}>
//           {error}
//         </Alert>
//       )}

//       {/* Liste des catégories */}
//       <Card className="border-0 shadow-sm">
//         <Card.Header className="bg-white border-0 py-3">
//           <h5 className="mb-0">
//             Liste des catégories ({filteredCategories.length})
//           </h5>
//         </Card.Header>
//         <Card.Body className="p-0">
//           {filteredCategories.length === 0 ? (
//             <div className="text-center py-5">
//               <Tag size={48} className="text-muted mb-3" />
//               <h5 className="text-muted">
//                 {searchQuery ? 'Aucune catégorie trouvée' : 'Aucune catégorie créée'}
//               </h5>
//               <p className="text-muted mb-3">
//                 {searchQuery 
//                   ? 'Essayez avec d\'autres mots-clés'
//                   : 'Commencez par créer votre première catégorie'
//                 }
//               </p>
//               {!searchQuery && (
//                 <Button variant="primary" 
//                 type="button"
//                 onClick={openCreateModal}>
//                   <Plus size={16} className="me-1" />
//                   Créer une catégorie
//                 </Button>
//               )}
//             </div>
//           ) : (
//             <Table responsive hover className="mb-0">
//               <thead className="bg-light">
//                 <tr>
//                   <th>Catégorie</th>
//                   <th>Produits</th>
//                   <th>Couleur</th>
//                   <th>Créée le</th>
//                   <th width="120">Actions</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {filteredCategories.map((category) => (
//                   <tr key={category.id}>
//                     <td>
//                       <div className="d-flex align-items-center">
//                         <span 
//                           className="me-2"
//                           style={{ fontSize: '1.5rem' }}
//                         >
//                           {category.icon}
//                         </span>
//                         <div>
//                           <div className="fw-medium">{category.name}</div>
//                           <small className="text-muted">ID: {category.id?.slice(0, 8)}...</small>
//                         </div>
//                       </div>
//                     </td>
//                     <td>
//                       <Badge 
//                         bg={category.product_count > 0 ? "success" : "secondary"}
//                         className="d-flex align-items-center gap-1"
//                         style={{ width: 'fit-content' }}
//                       >
//                         <Package size={12} />
//                         {category.product_count || 0}
//                       </Badge>
//                     </td>
//                     <td>
//                       <div className="d-flex align-items-center gap-2">
//                         <div
//                           className="rounded"
//                           style={{ 
//                             width: '20px', 
//                             height: '20px', 
//                             backgroundColor: category.color 
//                           }}
//                         />
//                         <small className="text-muted">{category.color}</small>
//                       </div>
//                     </td>
//                     <td>
//                       <small className="text-muted">
//                         {category.createdAt 
//                           ? new Date(category.createdAt).toLocaleDateString('fr-FR')
//                           : '-'
//                         }
//                       </small>
//                     </td>
//                     <td>
//                       <div className="d-flex gap-1">
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           onClick={() => openEditModal(category)}
//                           title="Modifier"
//                         >
//                           <Edit size={14} />
//                         </Button>
//                         <Button
//                           variant="outline-danger"
//                           size="sm"
//                           onClick={() => openDeleteModal(category)}
//                           disabled={category.product_count > 0}
//                           title={category.product_count > 0 
//                             ? "Impossible de supprimer - catégorie utilisée" 
//                             : "Supprimer"
//                           }
//                         >
//                           <Trash2 size={14} />
//                         </Button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Modal de création */}
//       <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="lg">
//         <CategoryForm
//           onSubmit={handleCreate}
//           title="🆕 Créer une nouvelle catégorie"
//           submitText="Créer"
//         />
//       </Modal>

//       {/* Modal de modification */}
//       <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
//         <CategoryForm
//           onSubmit={handleEdit}
//           title="✏️ Modifier la catégorie"
//           submitText="Modifier"
//         />
//       </Modal>

//       {/* Modal de suppression */}
//       <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
//         <Modal.Header closeButton>
//           <Modal.Title>🗑️ Supprimer la catégorie</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Alert variant="warning">
//             <strong>Attention !</strong> Cette action est irréversible.
//           </Alert>
//           <p>
//             Êtes-vous sûr de vouloir supprimer la catégorie 
//             <strong> "{selectedCategory?.name}"</strong> ?
//           </p>
//           {selectedCategory?.product_count > 0 && (
//             <Alert variant="danger">
//               Cette catégorie contient {selectedCategory.product_count} produit(s). 
//               Vous devez d'abord les réassigner ou les supprimer.
//             </Alert>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" 
//           type="button"
//           onClick={() => setShowDeleteModal(false)}>
//             Annuler
//           </Button>
//           <Button 
//             variant="danger" 
//             onClick={handleDelete}
//             disabled={submitting || selectedCategory?.product_count > 0}
//           >
//             {submitting ? (
//               <>
//                 <span className="spinner-border spinner-border-sm me-2" />
//                 Suppression...
//               </>
//             ) : (
//               <>
//                 <Trash2 size={16} className="me-1" />
//                 Supprimer
//               </>
//             )}
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Styles */}
//       <style jsx>{`
//         .card {
//           transition: all 0.2s ease;
//         }
        
//         .card:hover {
//           transform: translateY(-1px);
//         }
        
//         .table td {
//           vertical-align: middle;
//         }
        
//         .btn-sm {
//           padding: 0.375rem 0.5rem;
//         }
        
//         @media (max-width: 768px) {
//           .d-flex.gap-2 {
//             flex-direction: column;
//             gap: 0.5rem !important;
//           }
          
//           .table-responsive {
//             font-size: 0.875rem;
//           }
//         }
//       `}</style>
//     </Container>
//   );
// };

// export default CategoriesManagement;






















import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Badge, Table, Form, InputGroup, Modal, Alert } from 'react-bootstrap';
import { 
  Plus, 
  Search, 
  Edit, 
  Trash2, 
  Tag,
  Package,
  RefreshCw,
  BarChart3,
  Palette,
  Save,
  X,
  Eye
} from 'lucide-react';
import productService from '../../services/productService';
import LoadingSpinner from '../common/LoadingSpinner';

const CategoriesManagement = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  
  // Modal states
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  
  // Form states - séparés pour éviter les conflits
  const [createFormData, setCreateFormData] = useState({
    name: '',
    icon: '📦',
    color: '#3b82f6'
  });
  
  const [editFormData, setEditFormData] = useState({
    name: '',
    icon: '📦',
    color: '#3b82f6'
  });
  
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);

  // Emojis populaires pour les catégories
  const popularIcons = [
    '📦', '🛍️', '👕', '👔', '👗', '👠', '👟', '🎒', '📱', '💻',
    '🏠', '🍔', '🍕', '☕', '🍰', '🚗', '⚽', '🎮', '📚', '💊',
    '🌟', '💎', '🎯', '🔧', '🎨', '🎪', '🎵', '🎬', '📸', '🌸'
  ];

  useEffect(() => {
    loadCategories();
  }, []);

  const loadCategories = async () => {
    try {
      setLoading(true);
      setError(null);
      
      console.log('🏷️ Chargement des catégories...');
      const response = await productService.getCategories();
      
      if (response.success) {
        setCategories(response.data || []);
        console.log('✅ Catégories chargées:', response.data?.length || 0);
      } else {
        setError(response.message || 'Erreur lors du chargement des catégories');
      }
    } catch (error) {
      console.error('❌ Erreur lors du chargement des catégories:', error);
      setError('Erreur de connexion');
    } finally {
      setLoading(false);
    }
  };

  const filteredCategories = categories.filter(category =>
    category.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const validateForm = (formData) => {
    const errors = {};
    
    if (!formData.name?.trim()) {
      errors.name = 'Le nom est requis';
    } else if (formData.name.trim().length < 2) {
      errors.name = 'Le nom doit contenir au moins 2 caractères';
    }
    
    if (!formData.icon) {
      errors.icon = 'Une icône est requise';
    }
    
    if (!formData.color || !/^#[0-9A-Fa-f]{6}$/.test(formData.color)) {
      errors.color = 'Couleur invalide (format #RRGGBB requis)';
    }
    
    return errors;
  };

  // ===== GESTION CRÉATION =====
  
  const handleCreateInputChange = (field, value) => {
    console.log('📝 Create input change:', field, value);
    setCreateFormData(prev => {
      const newData = { ...prev, [field]: value };
      console.log('📝 New create data:', newData);
      return newData;
    });
    
    if (formErrors[field]) {
      setFormErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    console.log('🔄 Soumission création:', createFormData);
    
    const errors = validateForm(createFormData);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    try {
      setSubmitting(true);
      setFormErrors({});
      
      const response = await productService.createCategory({
        name: createFormData.name.trim(),
        icon: createFormData.icon,
        color: createFormData.color
      });
      
      if (response.success) {
        await loadCategories();
        setShowCreateModal(false);
        setCreateFormData({ name: '', icon: '📦', color: '#3b82f6' });
      } else {
        setFormErrors({ submit: response.message });
      }
    } catch (error) {
      console.error('❌ Erreur création catégorie:', error);
      setFormErrors({ submit: 'Erreur lors de la création' });
    } finally {
      setSubmitting(false);
    }
  };

  const openCreateModal = () => {
    console.log('🆕 Ouverture modal création');
    setCreateFormData({ name: '', icon: '📦', color: '#3b82f6' });
    setFormErrors({});
    setSelectedCategory(null);
    setShowCreateModal(true);
  };

  // ===== GESTION MODIFICATION =====
  
  const handleEditInputChange = (field, value) => {
    console.log('✏️ Edit input change:', field, value);
    setEditFormData(prev => {
      const newData = { ...prev, [field]: value };
      console.log('✏️ New edit data:', newData);
      return newData;
    });
    
    if (formErrors[field]) {
      setFormErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    console.log('🔄 Soumission modification:', editFormData);
    
    const errors = validateForm(editFormData);
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    try {
      setSubmitting(true);
      setFormErrors({});
      
      const response = await productService.updateCategory(selectedCategory.id, {
        name: editFormData.name.trim(),
        icon: editFormData.icon,
        color: editFormData.color
      });
      
      if (response.success) {
        await loadCategories();
        setShowEditModal(false);
        setSelectedCategory(null);
      } else {
        setFormErrors({ submit: response.message });
      }
    } catch (error) {
      console.error('❌ Erreur modification catégorie:', error);
      setFormErrors({ submit: 'Erreur lors de la modification' });
    } finally {
      setSubmitting(false);
    }
  };

  const openEditModal = (category) => {
    console.log('✏️ Ouverture modal modification:', category);
    setSelectedCategory(category);
    setEditFormData({
      name: category.name || '',
      icon: category.icon || '📦',
      color: category.color || '#3b82f6'
    });
    setFormErrors({});
    setShowEditModal(true);
  };

  // ===== GESTION SUPPRESSION =====
  
  const handleDelete = async () => {
    if (!selectedCategory) return;
    
    try {
      setSubmitting(true);
      
      const response = await productService.deleteCategory(selectedCategory.id);
      
      if (response.success) {
        await loadCategories();
        setShowDeleteModal(false);
        setSelectedCategory(null);
      } else {
        setError(response.message);
      }
    } catch (error) {
      console.error('❌ Erreur suppression catégorie:', error);
      setError('Erreur lors de la suppression');
    } finally {
      setSubmitting(false);
    }
  };

  const openDeleteModal = (category) => {
    setSelectedCategory(category);
    setShowDeleteModal(true);
  };

  // ===== COMPOSANTS DE FORMULAIRE =====
  
  const CreateCategoryForm = () => (
    <Form onSubmit={handleCreateSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>🆕 Créer une nouvelle catégorie</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {formErrors.submit && (
          <Alert variant="danger" className="mb-3">
            {formErrors.submit}
          </Alert>
        )}
        
        <Form.Group className="mb-3">
          <Form.Label>Nom de la catégorie *</Form.Label>
          <InputGroup>
            <InputGroup.Text><Tag size={16} /></InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Ex: Vêtements, Électronique..."
              value={createFormData.name}
              onChange={(e) => handleCreateInputChange('name', e.target.value)}
              isInvalid={!!formErrors.name}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.name}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Icône *</Form.Label>
          <div className="mb-2">
            <Form.Control
              type="text"
              placeholder="📦"
              value={createFormData.icon}
              onChange={(e) => handleCreateInputChange('icon', e.target.value)}
              isInvalid={!!formErrors.icon}
              style={{ fontSize: '1.2rem' }}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.icon}
            </Form.Control.Feedback>
          </div>
          
          <div className="d-flex flex-wrap gap-2">
            <small className="text-muted w-100 mb-2">Icônes populaires :</small>
            {popularIcons.map((icon, index) => (
              <Button
                key={index}
                variant={createFormData.icon === icon ? "primary" : "outline-secondary"}
                size="sm"
                className="p-2"
                type="button"
                onClick={() => handleCreateInputChange('icon', icon)}
                style={{ fontSize: '1.2rem', width: '40px', height: '40px' }}
              >
                {icon}
              </Button>
            ))}
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Couleur *</Form.Label>
          <div className="d-flex align-items-center gap-3">
            <Form.Control
              type="color"
              value={createFormData.color}
              onChange={(e) => handleCreateInputChange('color', e.target.value)}
              style={{ width: '60px', height: '40px' }}
            />
            <Form.Control
              type="text"
              value={createFormData.color}
              onChange={(e) => handleCreateInputChange('color', e.target.value)}
              placeholder="#3b82f6"
              isInvalid={!!formErrors.color}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.color}
            </Form.Control.Feedback>
          </div>
        </Form.Group>

        <Card className="bg-light">
          <Card.Body className="py-2">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: '1.5rem' }}>{createFormData.icon}</span>
              <span 
                className="px-2 py-1 rounded text-white fw-medium"
                style={{ backgroundColor: createFormData.color }}
              >
                {createFormData.name || 'Nom de la catégorie'}
              </span>
            </div>
            <small className="text-muted">Aperçu de la catégorie</small>
          </Card.Body>
        </Card>
      </Modal.Body>
      
      <Modal.Footer>
        <Button 
          variant="secondary" 
          type="button"
          onClick={() => setShowCreateModal(false)}
          disabled={submitting}
        >
          <X size={16} className="me-1" />
          Annuler
        </Button>
        <Button 
          type="submit" 
          variant="primary"
          disabled={submitting}
        >
          {submitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Création...
            </>
          ) : (
            <>
              <Save size={16} className="me-1" />
              Créer
            </>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  );

  const EditCategoryForm = () => (
    <Form onSubmit={handleEditSubmit}>
      <Modal.Header closeButton>
        <Modal.Title>✏️ Modifier la catégorie</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {formErrors.submit && (
          <Alert variant="danger" className="mb-3">
            {formErrors.submit}
          </Alert>
        )}
        
        <Form.Group className="mb-3">
          <Form.Label>Nom de la catégorie *</Form.Label>
          <InputGroup>
            <InputGroup.Text><Tag size={16} /></InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Ex: Vêtements, Électronique..."
              value={editFormData.name}
              onChange={(e) => handleEditInputChange('name', e.target.value)}
              isInvalid={!!formErrors.name}
              autoFocus
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.name}
            </Form.Control.Feedback>
          </InputGroup>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Icône *</Form.Label>
          <div className="mb-2">
            <Form.Control
              type="text"
              placeholder="📦"
              value={editFormData.icon}
              onChange={(e) => handleEditInputChange('icon', e.target.value)}
              isInvalid={!!formErrors.icon}
              style={{ fontSize: '1.2rem' }}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.icon}
            </Form.Control.Feedback>
          </div>
          
          <div className="d-flex flex-wrap gap-2">
            <small className="text-muted w-100 mb-2">Icônes populaires :</small>
            {popularIcons.map((icon, index) => (
              <Button
                key={index}
                variant={editFormData.icon === icon ? "primary" : "outline-secondary"}
                size="sm"
                className="p-2"
                type="button"
                onClick={() => handleEditInputChange('icon', icon)}
                style={{ fontSize: '1.2rem', width: '40px', height: '40px' }}
              >
                {icon}
              </Button>
            ))}
          </div>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Couleur *</Form.Label>
          <div className="d-flex align-items-center gap-3">
            <Form.Control
              type="color"
              value={editFormData.color}
              onChange={(e) => handleEditInputChange('color', e.target.value)}
              style={{ width: '60px', height: '40px' }}
            />
            <Form.Control
              type="text"
              value={editFormData.color}
              onChange={(e) => handleEditInputChange('color', e.target.value)}
              placeholder="#3b82f6"
              isInvalid={!!formErrors.color}
            />
            <Form.Control.Feedback type="invalid">
              {formErrors.color}
            </Form.Control.Feedback>
          </div>
        </Form.Group>

        <Card className="bg-light">
          <Card.Body className="py-2">
            <div className="d-flex align-items-center gap-2">
              <span style={{ fontSize: '1.5rem' }}>{editFormData.icon}</span>
              <span 
                className="px-2 py-1 rounded text-white fw-medium"
                style={{ backgroundColor: editFormData.color }}
              >
                {editFormData.name || 'Nom de la catégorie'}
              </span>
            </div>
            <small className="text-muted">Aperçu de la catégorie</small>
          </Card.Body>
        </Card>
      </Modal.Body>
      
      <Modal.Footer>
        <Button 
          variant="secondary" 
          type="button"
          onClick={() => setShowEditModal(false)}
          disabled={submitting}
        >
          <X size={16} className="me-1" />
          Annuler
        </Button>
        <Button 
          type="submit" 
          variant="primary"
          disabled={submitting}
        >
          {submitting ? (
            <>
              <span className="spinner-border spinner-border-sm me-2" />
              Modification...
            </>
          ) : (
            <>
              <Save size={16} className="me-1" />
              Modifier
            </>
          )}
        </Button>
      </Modal.Footer>
    </Form>
  );

  if (loading) {
    return <LoadingSpinner message="Chargement des catégories..." />;
  }

  return (
    <Container fluid className="py-4">
      {/* En-tête */}
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h1 className="h3 mb-1">
                <Tag className="me-2" size={28} />
                Gestion des Catégories
              </h1>
              <p className="text-muted mb-0">
                Organisez vos produits par catégories pour faciliter la navigation
              </p>
            </div>
            <div className="d-flex gap-2">
              <Button variant="outline-primary" onClick={loadCategories}>
                <RefreshCw size={16} className="me-1" />
                Actualiser
              </Button>
              <Button variant="primary" onClick={openCreateModal}>
                <Plus size={16} className="me-1" />
                Nouvelle catégorie
              </Button>
            </div>
          </div>
        </Col>
      </Row>

      {/* Statistiques */}
      <Row className="mb-4">
        <Col lg={3} md={6} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="bg-primary rounded p-3 me-3">
                  <Tag size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="mb-1">{categories.length}</h3>
                  <p className="text-muted mb-0 small">Total catégories</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={3} md={6} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="bg-success rounded p-3 me-3">
                  <Package size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="mb-1">
                    {categories.reduce((sum, cat) => sum + (cat.product_count || 0), 0)}
                  </h3>
                  <p className="text-muted mb-0 small">Produits associés</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={3} md={6} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="bg-warning rounded p-3 me-3">
                  <BarChart3 size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="mb-1">
                    {categories.filter(cat => (cat.product_count || 0) > 0).length}
                  </h3>
                  
                  <p className="text-muted mb-0 small">Catégories actives</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
        
        <Col lg={3} md={6} className="mb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body>
              <div className="d-flex align-items-center">
                <div className="bg-info rounded p-3 me-3">
                  <Palette size={24} className="text-white" />
                </div>
                <div>
                  <h3 className="mb-1">
                    {new Set(categories.map(cat => cat.color)).size}
                  </h3>
                  <p className="text-muted mb-0 small">Couleurs utilisées</p>
                </div>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Barre de recherche */}
      <Row className="mb-4">
        <Col lg={6}>
          <InputGroup>
            <InputGroup.Text>
              <Search size={16} />
            </InputGroup.Text>
            <Form.Control
              type="text"
              placeholder="Rechercher une catégorie..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </InputGroup>
        </Col>
      </Row>

      {/* Messages d'erreur */}
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)}>
          {error}
        </Alert>
      )}

      {/* Liste des catégories */}
      <Card className="border-0 shadow-sm">
        <Card.Header className="bg-white border-0 py-3">
          <h5 className="mb-0">
            Liste des catégories ({filteredCategories.length})
          </h5>
        </Card.Header>
        <Card.Body className="p-0">
          {filteredCategories.length === 0 ? (
            <div className="text-center py-5">
              <Tag size={48} className="text-muted mb-3" />
              <h5 className="text-muted">
                {searchQuery ? 'Aucune catégorie trouvée' : 'Aucune catégorie créée'}
              </h5>
              <p className="text-muted mb-3">
                {searchQuery 
                  ? 'Essayez avec d\'autres mots-clés'
                  : 'Commencez par créer votre première catégorie'
                }
              </p>
              {!searchQuery && (
                <Button variant="primary" onClick={openCreateModal}>
                  <Plus size={16} className="me-1" />
                  Créer une catégorie
                </Button>
              )}
            </div>
          ) : (
            <Table responsive hover className="mb-0">
              <thead className="bg-light">
                <tr>
                  <th>Catégorie</th>
                  <th>Produits</th>
                  <th>Couleur</th>
                  <th>Créée le</th>
                  <th width="120">Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredCategories.map((category) => (
                  <tr key={category.id}>
                    <td>
                      <div className="d-flex align-items-center">
                        <span 
                          className="me-2"
                          style={{ fontSize: '1.5rem' }}
                        >
                          {category.icon}
                        </span>
                        <div>
                          <div className="fw-medium">{category.name}</div>
                          <small className="text-muted">ID: {category.id?.slice(0, 8)}...</small>
                        </div>
                      </div>
                    </td>
                    <td>
                      <Badge 
                        bg={category.product_count > 0 ? "success" : "secondary"}
                        className="d-flex align-items-center gap-1"
                        style={{ width: 'fit-content' }}
                      >
                        <Package size={12} />
                        {category.product_count || 0}
                      </Badge>
                    </td>
                    <td>
                      <div className="d-flex align-items-center gap-2">
                        <div
                          className="rounded"
                          style={{ 
                            width: '20px', 
                            height: '20px', 
                            backgroundColor: category.color 
                          }}
                        />
                        <small className="text-muted">{category.color}</small>
                      </div>
                    </td>
                    <td>
                      <small className="text-muted">
                        {category.createdAt 
                          ? new Date(category.createdAt).toLocaleDateString('fr-FR')
                          : '-'
                        }
                      </small>
                    </td>
                    <td>
                      <div className="d-flex gap-1">
                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => openEditModal(category)}
                          title="Modifier"
                        >
                          <Edit size={14} />
                        </Button>
                        <Button
                          variant="outline-danger"
                          size="sm"
                          onClick={() => openDeleteModal(category)}
                          disabled={category.product_count > 0}
                          title={category.product_count > 0 
                            ? "Impossible de supprimer - catégorie utilisée" 
                            : "Supprimer"
                          }
                        >
                          <Trash2 size={14} />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>

      {/* Modal de création */}
      <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)} size="lg">
        <CreateCategoryForm />
      </Modal>

      {/* Modal de modification */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} size="lg">
        <EditCategoryForm />
      </Modal>

      {/* Modal de suppression */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>🗑️ Supprimer la catégorie</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="warning">
            <strong>Attention !</strong> Cette action est irréversible.
          </Alert>
          <p>
            Êtes-vous sûr de vouloir supprimer la catégorie 
            <strong> "{selectedCategory?.name}"</strong> ?
          </p>
          {selectedCategory?.product_count > 0 && (
            <Alert variant="danger">
              Cette catégorie contient {selectedCategory.product_count} produit(s). 
              Vous devez d'abord les réassigner ou les supprimer.
            </Alert>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Annuler
          </Button>
          <Button 
            variant="danger" 
            onClick={handleDelete}
            disabled={submitting || selectedCategory?.product_count > 0}
          >
            {submitting ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Suppression...
              </>
            ) : (
              <>
                <Trash2 size={16} className="me-1" />
                Supprimer
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Styles */}
      <style jsx>{`
        .card {
          transition: all 0.2s ease;
        }
        
        .card:hover {
          transform: translateY(-1px);
        }
        
        .table td {
          vertical-align: middle;
        }
        
        .btn-sm {
          padding: 0.375rem 0.5rem;
        }
        
        @media (max-width: 768px) {
          .d-flex.gap-2 {
            flex-direction: column;
            gap: 0.5rem !important;
          }
          
          .table-responsive {
            font-size: 0.875rem;
          }
        }
      `}</style>
    </Container>
  );
};

export default CategoriesManagement;